import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '.collection-form': {
    '&__submit-btn': {
      margin: `${theme.space[4]} 0`,
    },
  },
});
